import { Model } from 'json-api-models';

import type { Models, Schemas } from '../models.ts';

export class VideoRevision extends Model<Schemas['videoRevisions'], Models> {
    get uploadedThumbnailUrl(): string | null {
        return this.thumbnail?.[0]?.url || null;
    }

    get thumbnailUrl(): string | null {
        return this.uploadedThumbnailUrl || this.posterUrl || null;
    }
}
